"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_call__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aa3d246c-c280-4245-8633-34a032d82e92",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ad5fb27b-1684-40d4-a222-fbac43e63cbc{fill:#fff;}.b49ebb70-2361-4eb8-8050-b7af00862f30{opacity:0.06;}.e3c9638b-2b6f-450b-bfd5-92cae7a72e93{fill:none;}.e747cfed-fdd5-43de-824a-a58ac82a866e{fill:#e60000;}.e319377e-6f64-4d7a-801e-f383e4f3f2d9{fill:#f4f4f4;}.a3734f2c-9166-4c17-b602-bb415bf9d4a6{opacity:0.12;}")), /*#__PURE__*/React.createElement("title", null, "call-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "addb5c32-ac69-49be-81b5-bb883f486e1f",
    "data-name": "Call_ic_hi 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad5fb27b-1684-40d4-a222-fbac43e63cbc",
    d: "M114.94,127.84l12.2-9.2c3.22-1.65,6.54-2,8.54-.82,3,1.86,28.44,18.87,30.59,20.37s3.13,5.78.12,9.94-16.78,20.58-22.55,20.37-29.79-.91-74.62-46S24.12,53.63,24,47.92,40.72,28.86,45,26s8.56-1.77,10.05.3C56.71,28.62,73.27,54,75.09,56.86c1.24,2,.75,5.27-1,8.43s-8.86,15.23-8.86,15.23,4.86,8.37,21.41,25C94.53,113.61,114.94,127.84,114.94,127.84Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b49ebb70-2361-4eb8-8050-b7af00862f30",
    d: "M166.39,146.13c-3,4.16-16.78,20.58-22.55,20.37s-29.79-.91-74.62-46C27.46,78.47,24.37,55,24,47.34a4,4,0,0,0,0,.58c.12,5.71.41,29.48,45.22,74.57s68.84,45.79,74.62,46,19.55-16.21,22.55-20.37a8.83,8.83,0,0,0,1.81-6.37A9.55,9.55,0,0,1,166.39,146.13Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3c9638b-2b6f-450b-bfd5-92cae7a72e93",
    d: "M114.94,127.84h0l-.3-.18Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e747cfed-fdd5-43de-824a-a58ac82a866e",
    d: "M67.55,76.62c-5.16-8-19.84-30.48-29.6-45.22-1,.83-2,1.71-3.06,2.63C45.52,50.1,61.79,75,65.27,80.48,65.41,80.25,66.34,78.68,67.55,76.62Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e319377e-6f64-4d7a-801e-f383e4f3f2d9",
    d: "M114.66,127.65l-.16-.11h0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e747cfed-fdd5-43de-824a-a58ac82a866e",
    d: "M118.37,125.26,115,127.83c5.29,3.32,25.93,17.07,44,29.18.94-1,1.85-2,2.68-3C144.66,142.61,125.27,129.69,118.37,125.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3734f2c-9166-4c17-b602-bb415bf9d4a6",
    d: "M35.73,33.3l-.84.73C45.52,50.1,61.79,75,65.27,80.48c.14-.23,1.07-1.8,2.28-3.86l-.62-1c-.89,1.52-1.54,2.62-1.66,2.81C61.88,73.15,46.35,49.38,35.73,33.3Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3734f2c-9166-4c17-b602-bb415bf9d4a6",
    d: "M159,155c-16.73-11.21-35.65-23.82-42.57-28.26L115,127.83c5.29,3.32,25.93,17.07,44,29.18.94-1,1.85-2,2.68-3l-1.1-.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b49ebb70-2361-4eb8-8050-b7af00862f30",
    d: "M67.5,76.71c2.25-3.82,5.52-9.42,6.61-11.42a11.19,11.19,0,0,0,1.6-6.64,13.38,13.38,0,0,1-1.6,4.64c-1.17,2.16-4.88,8.48-7.11,12.26",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e3c9638b-2b6f-450b-bfd5-92cae7a72e93",
    width: 192,
    height: 192
  })));
}

var _default = ic_call__dark;
exports.default = _default;